export default "__VITE_PUBLIC_ASSET__f4538f70__"